import React from 'react';
import Switch from 'components/Switch';
import styles from './styles.scss';

const TimelineViewToggle = ({ isSystemTimeline, onToggle }) => (
  <div className={styles.timelineViewToggle}>
    <span
      className={
        isSystemTimeline
          ? styles.toggleLabel
          : `${styles.toggleLabel} ${styles.activeLabel}`
      }
    >
      Tracking Event Timeline
    </span>
    <Switch
      id="timeline-view-toggle"
      enabled={isSystemTimeline}
      toggle={() => onToggle(!isSystemTimeline)}
      isLabelEnabled={false}
    />
    <span
      className={
        isSystemTimeline
          ? `${styles.toggleLabel} ${styles.activeLabel}`
          : styles.toggleLabel
      }
    >
      System Event Timeline
    </span>
  </div>
);

export default TimelineViewToggle;
